import { MessageCircleIcon } from "lucide-react";

/** Slow horizontal strip of chat bubbles. Pauses on hover; stops under reduced motion (index.css). */
export function Marquee({ items, caption }) {
  const loop = [...items, ...items];

  return (
    <section
      aria-label="Questions customers ask on WhatsApp"
      className="border-y border-border bg-surface-soft py-6"
    >
      <div className="group mask-fade-x overflow-hidden">
        <ul className="flex w-max animate-marquee gap-3 group-hover:[animation-play-state:paused]">
          {loop.map((text, i) => (
            <li
              key={i}
              aria-hidden={i >= items.length}
              className="flex shrink-0 items-center gap-2 rounded-lg rounded-tl-none border border-border bg-background px-4 py-2.5 text-sm shadow-card"
            >
              <MessageCircleIcon
                className="size-4 text-brand"
                aria-hidden="true"
              />
              {text}
            </li>
          ))}
        </ul>
      </div>

      {caption && (
        <p className="mt-4 px-4 text-center text-sm text-muted-foreground">
          {caption}
        </p>
      )}
    </section>
  );
}